import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';

import { NotificationService } from 'src/app/core/notification/notification';
import { environment } from '../../../environments/environment';
import { MultiFacilityService } from '../services/multi-facility.service';

@Component({
  selector: 'app-post-login-header',
  templateUrl: './post-login-header.component.html',
  styleUrls: ['./post-login-header.component.scss'],
})
export class PostLoginHeaderComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  cloudBasePath: string;
  assetsPath: string;
  private showMultisiteSelector: boolean | undefined = false;

  @Input() isAuthSuccess: boolean;
  @Input() fcHybridLegacHalo: boolean;
  @Output() onsignout: EventEmitter<string> = new EventEmitter();

  constructor(
    private rootScopeService: RootScopeService,
    private router: Router,
    public notificationService: NotificationService,
    private multiFacilityService: MultiFacilityService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
        this.showMultisiteSelector = this.multiFacilityService.isMultifacilityUrl(this.router.url);
      }
    });
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;
    this.assetsPath = environment.assetsPath;
    this.showMultisiteSelector = this.multiFacilityService.isMultifacilityUrl(this.router.url);
  }

  proceedSignout() {
    this.onsignout.emit();
  }

  tryToMoveAwayFromCurrentPage(path: string): boolean {
    this.rootScopeData.pathToNavigate = path;
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      return false;
    } else {
      if (this.rootScopeData.pathToNavigate !== this.router.url) {
        window.location.href = 'halo.html#' + this.rootScopeData.pathToNavigate;
      }
      return true;
    }
  }

  toggleNotification() {
    this.notificationService.toggleVisibleState();
  }
}
